enum ContactReasons {
  Order = 'order',
  Wismo = 'wismo',
  Cancellation = 'cancellation',
  Account = 'account',
  Delivery = 'delivery',
  Return = 'return',
  Products = 'products',
  Shop = 'shop',
  Claim = 'claim',
}

export default ContactReasons;
